/** Claves compartidas (evitar duplicar strings entre módulos). */
export const PWA_JWT_STORAGE_KEY = 'va_company_pwa_jwt';
export const PWA_OPAQUE_STORAGE_KEY = 'va_company_pwa_opaque';
/** Dispositivo con push activado (permiso + suscripción registrada). */
export const PWA_PUSH_ACK_KEY = 'va_pwa_push_ack';
